import { jsx as _jsx } from "react/jsx-runtime";
export const defaultWrapper = ({
  to,
  children,
  className: defaultClassName
}) => /*#__PURE__*/_jsx("a", {
  href: to,
  className: defaultClassName,
  children: children
});